'use strict';


TimesTampSvc.$inject = ['itxAkamaiSvc', 'preCommonTimestampSvc'];

function TimesTampSvc(itxAkamaiSvc, preCommonTimestampSvc) {

    var akamaiTimestamp;

    itxAkamaiSvc.getDate().then(function(time) {
       var minutesRounded = Math.round(time.minute() / 15) * 15;  // 0 / 15 / 30 / 45 / 60
       akamaiTimestamp = time.minute(minutesRounded).second(0).millisecond(0).utc().valueOf();
    });
    
    return {
        getTs : preCommonTimestampSvc.getTs,
        getAkamaiTs : function(){
            return akamaiTimestamp || moment().utc().valueOf();
        }
        
    };
}
 
angular.module('itxApp.common').service('timestampSvc', TimesTampSvc);